import { Pipe, PipeTransform } from '@angular/core';
import { FollowService } from '../services/follow.service';

@Pipe({
  name: 'followControl'
})
export class FollowControlPipe implements PipeTransform {

  constructor(
    private followServ: FollowService
  ) { }

  transform(itemId: number): boolean {
    return Boolean(this.followServ.follows.find(x => x.followed_id === itemId));
  }

}
